Ext.define('SA.ChartLegendEditLabelledTextItem', {
    alias: 'widget.chart-legend-edit-labelled-text-item',
    extend: 'SA.ChartLegendEditLabelledItem',

    cls: 'sa-chart-legend-edit-labelled-text-item',

    initComponent() {
        this.item = {
            xtype: 'component',
            cls: 'sa-chart-legend-edit-labelled-text-item-text'
        };

        this.callParent();

        this.textCmp = this.items[1];
    },

    setText(text) {
        this.textCmp.update(Ext.String.htmlEncode(text));
    }
});